import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchSpeakerAlertPreference } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const speakerAlertPreferenceSlice = createAsyncThunk(
	'get/speakerAlertPreferenceSlice',
	FetchSpeakerAlertPreference,
);

export const SpeakerAlertPreferenceSlice = createSlice({
	name: 'speakerAlertPreferenceSlice',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[speakerAlertPreferenceSlice.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[speakerAlertPreferenceSlice.rejected.toString()]: setAPIError,
		[speakerAlertPreferenceSlice.fulfilled.toString()]: (
			state: ReturnType<typeof INITIAL_STATE>,
			action: IAPI_ACTION<any>,
		) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[SpeakerAlertPreferenceSlice.name]: ReturnType<typeof SpeakerAlertPreferenceSlice.reducer>;
}

export const speakerAlertPreferenceSelector = (state: IStates): any => {
	return state[SpeakerAlertPreferenceSlice.name] || {};
};

export const useSpeakerAlertPreference = (): any => useSelector(speakerAlertPreferenceSelector);

export const getSpeakerAlertPreference =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(speakerAlertPreferenceSlice());
		return;
	};

export const resetSpeakerAlertPreference =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(SpeakerAlertPreferenceSlice.actions.RESET());
		return;
	};
